import React from 'react';
import { Icon } from './Icon.js';
export const IconBagShopping = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9 7V4C9 2.34315 10.3431 1 12 1C13.6569 1 15 2.34315 15 4V7", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M4 22H20L19 7H5.00004L4 22Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconBagShopping.js.map